

var introDisplay = function(){

    // intro
    var tds = new Date(2017, 7, 27); // month - 1 !!!
    var tds2 = new Date(2017, 7, 28);
    var now = new Date();

    // debugging 
    if (urlParams.timemachine == "on") {
        now = new Date(2017, 7, 27);
    } else if (urlParams.timemachine == "after") {
        now = new Date(2017, 7, 28);
    }

    //console.log(tds, "now", now, tds2);

    if (now < tds) {
        // before
        $(".intro-1").css("display", "block");
        $(".intro-2").css("display", "none");
        $(".intro-3").css("display", "none");
    } else if (now >= tds && now < tds2) {
        // today
        $(".intro-1").css("display", "none");
        $(".intro-2").css("display", "block");
        $(".intro-3").css("display", "none");
    } else {
        // after
        $(".intro-1").css("display", "none");
        $(".intro-2").css("display", "none");
        $(".intro-3").css("display", "block");

    }


};